import jsonwebtoken from "jsonwebtoken";

export const verifyAuth = () => {

  let data = JSON.parse(window.sessionStorage.getItem("usersession"))

  if (data && data.message !== "User Not found.") {
    var isExpired = false;
    const token = data.accessToken;
    var decodedToken = jsonwebtoken.decode(token, { complete: true });
    var dateNow = new Date();
    if (decodedToken.exp < dateNow.getTime())
      return false;
    else
      return true;
  }
  return false
};

export const isAdmin = () => {
  let data = JSON.parse(window.sessionStorage.getItem("usersession"))

  if (data.role === "Admin")
    return true;

  return false;
}